<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.attendance_review'),
                        href: meta.links.attendance_review_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.attendance_review_show,
                    },
                    {
                        name: $t('messages.absences_per_day_of_the_week'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <apexchart
                :type="daysChart.chart.type"
                height="350"
                :series="daysChart.series"
                :options="daysChart"
            ></apexchart>
        </div>

        <form method="GET" action="" @submit.prevent="submit">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 lg:grid-cols-8">
                <div class="sm:col-span-1">
                    <div>
                        <label for="min_absenteeism" class="block text-sm font-medium text-gray-700">
                            {{ $t('messages.absenteeism') }} (>%)
                        </label>
                        <div class="mt-1">
                            <input
                                type="number"
                                name="min_absenteeism"
                                id="min_absenteeism"
                                v-model="form.min_absenteeism"
                                min="1"
                                max="99"
                                step="1"
                                class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                            />
                        </div>
                    </div>
                </div>
                <div class="sm:col-span-1">
                    <div>
                        <label for="max_absenteeism" class="block text-sm font-medium text-gray-700">
                            {{ $t('messages.absenteeism') }} (&lt;%)
                        </label>
                        <div class="mt-1">
                            <input
                                type="number"
                                name="max_absenteeism"
                                id="max_absenteeism"
                                v-model="form.max_absenteeism"
                                min="1"
                                max="100"
                                step="1"
                                class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                            />
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label for="dayOfWeek" class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.trimester') }}
                    </label>
                    <div class="mt-1">
                        <label class="mr-1">
                            <input
                                :value="null"
                                v-model="form.trimester"
                                name="trimester"
                                type="radio"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ $t('messages.all') }}
                        </label>

                        <label class="mr-1" v-for="trimester in [1, 2, 3]" :key="trimester">
                            <input
                                v-model="form.trimester"
                                :value="trimester"
                                name="trimester"
                                type="radio"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ trimester }}
                        </label>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label for="dayOfWeek" class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.absences') }}
                    </label>
                    <div class="mt-1">
                        <label class="mr-1">
                            <input
                                :value="null"
                                name="unjustified"
                                v-model="form.unjustified"
                                type="radio"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ $t('messages.all') }}
                        </label>
                        <label class="mr-1">
                            <input
                                value="1"
                                name="unjustified"
                                v-model="form.unjustified"
                                type="radio"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ $t('messages.unjustified') }}
                        </label>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label for="country" class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div class="mt-3">
            {{ $t('messages.average') }}

            <div v-for="(avg, dayTurn) in perDay" :key="dayTurn">{{ dayTurn }}: {{ Math.round(avg) }}</div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'chart', 'group', 'perDay', 'filters'],
    data() {
        return {
            daysChart: JSON.parse(JSON.stringify(this.chart)),
            form: this.$inertia.form({
                min_absenteeism: this.filters.min_absenteeism,
                max_absenteeism: this.filters.max_absenteeism,
                trimester: this.filters.trimester,
                unjustified: this.filters.unjustified,
            }),
        };
    },
    methods: {
        submit() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
